import React from "react";
import { Text, View, Platform, StyleSheet } from "react-native";

import AppTheme from "../../AppTheme";
import appStyles from "../../../appStyles";
import IntegrationIcons from "../../common/icons/integrations";

export default function IntegrationsScore({ hours }) {
  return (
    <View style={[styles.container, appStyles.borderBottom]}>
      <View style={styles.scoreContainer}>
        <Text style={styles.scoreText}>{hours}</Text>
        <Text style={styles.scoreTextLabel}>hrs</Text>
      </View>
      <IntegrationIcons.ConfettieBg />
      <Text style={styles.scoreDescription}>
        Look at all of that time you’ve tracked automatically
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginVertical: 8,
    paddingBottom: 5,
  },
  scoreContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  scoreText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 49,
    lineHeight: 60,
    letterSpacing: 0.5,
    color: AppTheme.DEFAULT_COLOR,
  },
  scoreTextLabel: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.DEFAULT_COLOR,
    paddingTop: 22,
  },
  scoreDescription: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Italic" }),
    fontStyle: "italic",
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
});
